import styled from '@emotion/styled';

interface Props {
  upperCase?: boolean;
  bottom?: number;
  top?: number;
  left?: number;
  right?: number;
  color?: string;
  fontWeight?: 400 | 500 | 600 | 700;
}

const base = styled.p<Props>`
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom}px;
  margin-top: ${({ top }) => top}px;
  margin-left: ${({ left }) => left}px;
  margin-right: ${({ right }) => right}px;
  text-transform: ${({ upperCase }) => (upperCase ? 'uppercase' : 'none')};
  font-weight: ${({ fontWeight }) => fontWeight || 400};
`;

export const StyledParagraph1 = styled(base)<Props>`
  font-size: 32px;
  line-height: var(--lineHeightMedium);
  letter-spacing: var(--letterSpacing);
`;

export const StyledParagraph2 = styled(base)<Props>`
  font-size: 20px;
  line-height: var(--lineHeightMedium);
  letter-spacing: var(--letterSpacing);
`;

export const StyledParagraph3 = styled(base)<Props>`
  font-size: 16px;
  line-height: var(--lineHeightLarge);
  letter-spacing: var(--letterSpacing);
`;

export const StyledParagraph4 = styled(base)<Props>`
  font-size: 14px;
  line-height: var(--lineHeightSmall);
  letter-spacing: var(--letterSpacing);
`;

export const StyledParagraph5 = styled(base)<Props>`
  font-size: 12px;
  line-height: var(--lineHeightExtraLarge);
  letter-spacing: var(--letterSpacing);
`;
